import { render, staticRenderFns } from "./om-view.vue?vue&type=template&id=c6d6d840"
import script from "./om-view.vue?vue&type=script&lang=js"
export * from "./om-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports